"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var loading_actions_1 = require("./loading.actions");

function loadDataThen(loadingKey, then, error) {
  return function (source) {
    return source.pipe(operators_1.concatMap(function (action) {
      return rxjs_1.concat(rxjs_1.of(loading_actions_1.loadingStartAction(loadingKey)), then(action), rxjs_1.of(loading_actions_1.loadingSuccessAction(loadingKey))).pipe(operators_1.catchError(function (e) {
        var _a, _b, _c, _d;

        var axiosProblemResponse = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data;
        var axiosProblemTraceId = (_b = axiosProblemResponse === null || axiosProblemResponse === void 0 ? void 0 : axiosProblemResponse.extensions) === null || _b === void 0 ? void 0 : _b.traceId;
        var axiosProblemError = (_d = (_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errors;
        return error ? rxjs_1.concat(rxjs_1.of(loading_actions_1.loadingFailAction(loadingKey, e.message, {
          reasons: axiosProblemError,
          traceId: axiosProblemTraceId,
          originalError: e
        })), error(action, e)) : rxjs_1.of(loading_actions_1.loadingFailAction(loadingKey, e.message, {
          reasons: axiosProblemError,
          traceId: axiosProblemTraceId,
          originalError: e
        }));
      }));
    }));
  };
}

exports.loadDataThen = loadDataThen;